import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M15.333 8A7.333 7.333 0 1 1 .666 8a7.333 7.333 0 0 1 14.667 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.926 1.902a7.333 7.333 0 1 1 8.148 12.195A7.333 7.333 0 0 1 3.926 1.902m7.74 4.723H4.334c-.764 0-.764.764-.764.764V8.61c0 .764.764.764.764.764h7.334c.764 0 .764-.764.764-.764V7.389c0-.764-.764-.764-.764-.764",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }